import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';
import { isSurveyWasTriggeredOnAppStart } from '@ocx-app/modules/survey/survey.reactive-variables';

import {
  SignupOtpSmsController,
  SignupOtpPhoneCallController,
  SignupWaitMessageController,
  SignupPhoneNumberFormController,
} from './features';
import { SignupLayout } from './signup.layout';
import { useSignupController } from './use-signup-controller.hook';

export const SignupController = () => {
  const {
    phoneNumber,
    handleRequestMagicLink,
    handleRequestOTP,
    handleSubmitOTP,
    isRequestMagicLinkLoading,
    isRequestOTPLoading,
    isSubmitOTPLoading,
    isBlockedByTimeout,
  } = useSignupController();

  useEffect(() => {
    if (isSurveyWasTriggeredOnAppStart()) {
      isSurveyWasTriggeredOnAppStart(false);
    }
  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <SignupLayout>
            <SignupPhoneNumberFormController
              phoneNumber={phoneNumber}
              handleRequestMagicLink={handleRequestMagicLink}
              handleRequestOTP={handleRequestOTP}
              isBlockedByTimeout={isBlockedByTimeout}
            />
          </SignupLayout>
        }
      />

      {phoneNumber && (
        <>
          <Route
            path={AppRoutePath.AuthOtpSmsRelative}
            element={
              <SignupLayout titleEnabled backButtonEnabled>
                <SignupOtpSmsController
                  phoneNumber={phoneNumber}
                  handleRequestMagicLink={handleRequestMagicLink}
                  handleRequestOTP={handleRequestOTP}
                  handleSubmitOTP={handleSubmitOTP}
                  isRequestMagicLinkLoading={isRequestMagicLinkLoading}
                  isRequestOTPLoading={isRequestOTPLoading}
                  isSubmitOTPLoading={isSubmitOTPLoading}
                  isBlockedByTimeout={isBlockedByTimeout}
                  isSubmitButtonsDisabled={isRequestMagicLinkLoading || isRequestOTPLoading || isSubmitOTPLoading}
                />
              </SignupLayout>
            }
          />
          <Route
            path={AppRoutePath.AuthOtpPhoneCallRelative}
            element={
              <SignupLayout titleEnabled backButtonEnabled>
                <SignupOtpPhoneCallController
                  phoneNumber={phoneNumber}
                  handleRequestMagicLink={handleRequestMagicLink}
                  handleRequestOTP={handleRequestOTP}
                  handleSubmitOTP={handleSubmitOTP}
                  isRequestMagicLinkLoading={isRequestMagicLinkLoading}
                  isRequestOTPLoading={isRequestOTPLoading}
                  isSubmitOTPLoading={isSubmitOTPLoading}
                  isBlockedByTimeout={isBlockedByTimeout}
                  isSubmitButtonsDisabled={isRequestMagicLinkLoading || isRequestOTPLoading || isSubmitOTPLoading}
                />
              </SignupLayout>
            }
          />
        </>
      )}

      {phoneNumber && (
        <Route
          path={AppRoutePath.AuthWaitMessageRelative}
          element={
            <SignupLayout titleEnabled backButtonEnabled>
              <SignupWaitMessageController
                phoneNumber={phoneNumber}
                handleRequestMagicLink={handleRequestMagicLink}
                handleRequestOTP={handleRequestOTP}
                isRequestMagicLinkLoading={isRequestMagicLinkLoading}
                isRequestOTPLoading={isRequestOTPLoading}
                isBlockedByTimeout={isBlockedByTimeout}
              />
            </SignupLayout>
          }
        />
      )}

      <Route path="*" element={<Navigate to={AppRoutePath.Auth} />} />
    </Routes>
  );
};
